// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__EIcwz","rotation":"Spinner_rotation__KDkC-"};